import { render, staticRenderFns } from "./ViewSCPDetail.vue?vue&type=template&id=be97a8e0&"
import script from "./ViewSCPDetail.vue?vue&type=script&lang=js&"
export * from "./ViewSCPDetail.vue?vue&type=script&lang=js&"
import style0 from "./ViewSCPDetail.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports